/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {
	BaseComponent,
	Dialog_Builder,
	DialogModule,
	ToastModule
} from "@intuitionrobotics/thunderstorm/frontend";
import {DialogTitle} from "../../../utils/DialogTitle";
import {
	PADDING_LEFT,
	PADDING_RIGHT
} from "../../../utils/AppDialog";
import {RadioButton} from "../../widget/RadioButton";
import {FONTS} from "@res/fonts";
import {OKButton} from "../../widget/OKButton";
import DragAndDrop from "../../widget/DragAndDrop";
import {COLORS} from "@res/colors";
import {ICONS} from "@res/icons";

type State = {
	uploadCustomThumbnail: boolean,
	thumbnailFile?: File
}

type Props = {
	onUploadThumbnail: (thumbnail: File) => void
}

export class UploadVideoThumbnailDialog
	extends BaseComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			uploadCustomThumbnail: false
		};
	}

	public static show(onUploadThumbnail: (thumbnail: File) => void) {
		new Dialog_Builder(<UploadVideoThumbnailDialog onUploadThumbnail={file => onUploadThumbnail(file)}/>)
			.addStyle({backgroundColor: "unset", boxShadow: "unset"})
			.setZIndex(900)
			.show();
	}

	render() {
		return <div className={"ll_v_s fill"} style={{width: 600, borderRadius: 4, background: "white"}}>
			<DialogTitle title={`Upload custom thumbnail`}/>
			<div className="ll_h_c" style={{marginTop: 20, paddingLeft: PADDING_LEFT, paddingRight: PADDING_RIGHT, marginBottom: 25}}>
				<RadioButton on={!this.state.uploadCustomThumbnail} onChange={() => this.setState({uploadCustomThumbnail: false})}/>No
				<div style={{marginLeft: 25}}>
					<RadioButton on={this.state.uploadCustomThumbnail} onChange={() => this.setState({uploadCustomThumbnail: true})}/>Yes
				</div>
			</div>
			{this.state.thumbnailFile && <div style={{display: "flex", margin: 25}}>
				<div className={"clickable"} onClick={() => this.setState({thumbnailFile: undefined})}>
					{ICONS.close(COLORS.red, 20)}
				</div>
				{FONTS.medium_12(this.state.thumbnailFile.name, {marginLeft: 10, color: COLORS.primary_dark_blue, alignSelf: "center"})}
			</div>}
			{this.state.uploadCustomThumbnail && !this.state.thumbnailFile && <div style={{backgroundColor: COLORS.primary_light_blue}}>
				<DragAndDrop height={"200px"} validate={["png",
				                                         "jpg",
				                                         "jpeg"]}
				             onChange={(files) => {
					             if (files.accepted.length > 1)
						             return ToastModule.toastError(
							             'Please upload only one file');

					             this.setState({thumbnailFile: files.accepted[0]})
				             }}
				/>
			</div>}
			<div className={`ll_h_c`} style={{justifyContent: "flex-end", marginTop: 50, marginBottom: 20, marginRight: 20}}>
				<div onClick={() => DialogModule.close()} style={{marginRight: 25, cursor: "pointer", backgroundColor: COLORS.neutral_gray_2, padding: '10px 15px'}}>
					{FONTS.reg_16_secondary_dark("Cancel")}
				</div>
				<OKButton
					text={"Save"}
					enabled={true}
					onClick={() => {
						const thumbnailFile = this.state.thumbnailFile;
						if (thumbnailFile)
							this.props.onUploadThumbnail(thumbnailFile)

						DialogModule.close()
					}}
				/>
			</div>
		</div>
	}
}
